// src/locales/en/footer.js
export const footer = {
    madeWithLove: "இலங்கை வணிகங்களுக்காக ❤️ உடன் செய்யப்பட்டது",
    helpCenter: "உதவி மையம்",
    privacyPolicy: "தனியுரிமைக் கொள்கை",
    termsOfService: "சேவை விதிமுறைகள்",
    documentation: "ஆவணப்படுத்தல்",
    copyright: "© {{year}} Rettzy"
}